// Normalisation au format de stockage en base : 0XXXXXXXXX (10 chiffres),
// null si le numéro n'est pas un numéro FR valide. C'est le format attendu
// par la recherche exacte de /api/rdv/identify.
export function normalizePhoneStorage(raw: string | number | null): string | null {
  if (raw == null) return null
  let s = String(raw).trim()
  // Remove everything except digits and leading +
  s = s.replace(/[^\d+]/g, "")
  // +33 / 0033 → 0, then drop any redundant leading 0 from +330XXXXXXXXX
  if (s.startsWith("+33")) s = "0" + s.slice(3).replace(/^0/, "")
  else if (s.startsWith("0033")) s = "0" + s.slice(4).replace(/^0/, "")
  // 9 digits without leading 0 (Excel "Number" format strips it): 612345678 → 0612345678
  else if (/^[1-9]\d{8}$/.test(s)) s = "0" + s
  // Must be 10 digits starting with 0
  if (!/^0[1-9]\d{8}$/.test(s)) return null
  // Reject all-zero or obviously fake
  if (/^0{10}$/.test(s)) return null
  return s
}

export function normalizePhone(phone: string): string {
  const digits = phone.replace(/[\s\-().]/g, "")
  if (digits.startsWith("+33")) return digits
  if (digits.startsWith("0033")) return "+" + digits.slice(2)
  if (digits.startsWith("0")) return "+33" + digits.slice(1)
  return digits
}

// Format pour affichage : +33612345678 → 06 12 34 56 78
export function formatPhone(phone: string): string {
  const normalized = normalizePhone(phone)
  if (!normalized.startsWith("+33") || normalized.length !== 12) return phone
  const local = "0" + normalized.slice(3)
  return local.replace(/(\d{2})(?=\d)/g, "$1 ").trim()
}

// Seuls les numéros 06 et 07 peuvent recevoir des SMS
export function isMobilePhone(phone: string): boolean {
  const normalized = normalizePhone(phone)
  return /^\+33[67]\d{8}$/.test(normalized)
}

// Préfixes (sans espaces) d'un mobile FR joignable par SMS, toutes variantes de
// saisie : local (06/07), international (+336/+337), +33 avec 0 redondant
// conservé (+3306/+3307), et équivalents 0033. Sert au filtrage SQL côté liste
// clients, où l'on ne peut pas appliquer normalizePhone().
export const SMS_MOBILE_PREFIXES = [
  "06",
  "07",
  "+336",
  "+337",
  "+3306",
  "+3307",
  "00336",
  "00337",
  "003306",
  "003307",
] as const
